import React from 'react';
import { connect } from 'react-redux';
import PaymentMethods from 'components/payment';
import { PaymentLogoList } from 'scy/PaymentLogo';
import { setPaymentMethod } from 'components/checkoutPage/actions';
import checkInView from 'shared/utils/checkInView';
import Icon from './Icon';
import Title from './Title';
import { flex, flex1 } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';

class Expanded extends React.Component {
  componentDidMount() {
    checkInView(this.container);
  }

  handleSelection(method) {
    return this.props
      .setPaymentMethod(method)
      .then(() => this.props.collapse());
  }

  render() {
    return (
      <div ref={div => (this.container = div)}>
        <div className={`${flex} ${margin.bottom_sm}`}>
          <Icon />
          <Title className={flex1} />
          <PaymentLogoList className={flex} itemClassName={margin.left_xxs} />
        </div>

        <PaymentMethods
          onSelectionSubmit={method => this.handleSelection(method)}
          onNewPaymentSuccess={method => this.handleSelection(method)}
          deliveryAddress={this.props.deliveryAddress}
        />
      </div>
    );
  }
}

const ConnectedExpanded = connect(
  state => ({
    deliveryAddress: state.address
  }),
  { setPaymentMethod }
)(Expanded);

export default ConnectedExpanded;
